var map = {
	"./PM_2.2.2.png": 77473,
	"./PM_2.3.2.png": 23805,
	"./PM_3.2.2.png": 13210,
	"components/Catalog/PM/img/glass/pr/prPlusBlack/PM_2.2.2.png": 77473,
	"components/Catalog/PM/img/glass/pr/prPlusBlack/PM_2.3.2.png": 23805,
	"components/Catalog/PM/img/glass/pr/prPlusBlack/PM_3.2.2.png": 13210
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 49859;